module.exports = __webpack_public_path__ + "img/exclamation-diamond-fill.3f712479.svg";